module.exports = __webpack_public_path__ + "static/img/icon3.5e126e00.png";